export enum MessageEnum {
  APPLICATION_MAP_SUCCESS = "Application Mapping - Success",
  APPLICATION_MAP_FAILURE = "Application Mapping - Failure",
  SURVEY_DETAILS_FAILURE = "Survey Fetch - Failure",
  SURVEY_SUBMIT_SUCCESS = "Survey Submit - Success",
  SURVEY_SUBMIT_FAILURE = "Survey Submit - Failure",
  FRAMEWORK_SUBMIT_SUCCESS = "Framework Submit - Success",
  FRAMEWORK_SUBMIT_FAILURE = "Framework Submit - Failure",
  SELF_HEALED_OBJECT_SAVE_SUCCESS = "Self-Healed Object Save - Success",
  SELF_HEALED_OBJECT_SAVE_FAILURE = "Self-Healed Object Save - Failure",
  LOAD_USER_STORIES_SUCCESS = "Load User Stories - Success",
  LOAD_USER_STORIES_FAILURE = "Load User Stories - Failure",
  LOAD_USER_STORY_ID_FAILURE = "Failed to Load Story IDs",
  USER_STORIES_EXTRACTION_FAILURE = "Extract User Stories from ALM - Failure",
  USER_STORY_PROGRESS_TRACKING_FAILURE = "Track User Story Progress - Failure",
  USER_ASSIGN_SUCCESS = "User Assignment - Success",
  USER_ASSIGN_FAILURE = "User Assignment - Failure",
  USER_INVITATION_SUCCESS = "User Invite - Success",
  USER_INVITATION_FAILURE = "User Invite - Failure",
  RECORDED_ACTIVITIES_LOAD_FAILURE = "Recorded Activities Load - Failure",
  DATA_SELECTION_NONE = "Data Selection Empty",
  TEST_SUITE_NAME_DUPLICATE = "Test Suite Name Already Exists",
  TEST_SUITE_NAME_ALREADY_EXISTS = "A test suite with this name already exists. Please enter a different name.",
  TEST_SCRIPT_NAME_DUPLICATE = "Test Script Name Already Exists",
  TEST_SUITE_CREATION_SUCCESS = "Test Suite Create - Success",
  TEST_SUITE_DELETION_SUCCESS = "Test Suite Delete - Success",
  TEST_SUITE_CREATION_FAILURE = "Test Suite Create - Failure",
  TEST_CASE_UPDATED_SUCCESS   = "Test Case Update - Success",
  TEST_CASE_UPDATED_FAILURE = "Test Case Update - Failure",
  TEST_CASE_DELETION_SUCCESS = "Test Case Delete - Success",
  TEST_CASE_ALREADY_MAPPED = "You cannot delete this test case because it is already mapped in TSG.",
  TEST_CASE_DELETION_FAILURE = "Test Case Delete - Failure",
  TEST_CASE_CREATION_SUCCESS = "Test Case Create - Success",
  TEST_CASE_CREATION_FAILURE = "Test Case Create - Failure",
  TEST_CASE_MAP_ID_NOT_FOUND = "Test case ID mapping is missing in ",
  TEST_CASE_MAP_ID_NOT_FOUND_PLAN = "Test case ID mapping is missing in some test cases in ",  
  AGENT_CREATION_SUCCESS = "Execution Engine Create - Success",
  AGENT_CREATION_FAILURE = "Execution Engine Create - Failure",
  AGENT_UPDATE_SUCCESS = "Execution Engine Update - Success",
  AGENT_UPDATE_FAILURE = "Execution Engine Update - Failure",
  AGENT_DELETION_SUCCESS = "Execution Engine Delete - Success",
  AGENT_DELETION_FAILURE = "Execution Engine Delete - Failure",
  AGENT_RECLAIM_SUCCESS = "Execution Engine Reclaim - Success",
  AGENT_RECLAIM_FAILURE = "Execution Engine Reclaim - Failure",
  AGENT_TOKEN_COPY_SUCCESS = "Execution Engine Token Copied to Clipboard",
  AGENT_EXECUTING_DELETE_FAILURE =  "Delete Restricted - 'Executing' Execution Engine Cannot Be Deleted",
  AGENT_LOAD_FAILURE = "Execution Engine Load - Failure",
  AGENT_DEVICE_LOAD_FAILURE = "Execution Engine Device Load - Failure",
  AUTOMATION_APPLICATION_CREATION_SUCCESS = "Application Create - Success",
  AUTOMATION_APPLICATION_DELETION_SUCCESS = "Application Delete - Success",
  AUTOMATION_APPLICATION_DELETION_FAILURE = "Application Delete - Failure",
  AUTOMATION_APPLICATION_DELETE_VALIDATION_FAILURE = "Application Delete Validation - Failure",
  AUTOMATION_APPLICATION_UPDATE_SUCCESS = "Application Update - Success",
  AUTOMATION_APPLICATION_UPDATE_FAILURE = "Application Update - Failure",
  AUTOMATION_PAGE_CREATION_SUCCESS = "Page Create - Success",
  AUTOMATION_PAGE_CREATION_FAILURE = "Page Create - Failure",
  AUTOMATION_PAGE_DELETION_SUCCESS = "Page Delete - Success",
  AUTOMATION_PAGE_DELETION_FAILURE = "Page Delete - Failure",
  AUTOMATION_PAGE_DELETE_VALIDATION_FAILURE = "Page Delete Validation - Failure",
  AUTOMATION_PAGE_UPDATE_SUCCESS = "Page Update - Success",
  AUTOMATION_PAGE_UPDATE_FAILURE = "Page Update - Failure",
  AUTOMATION_UI_OBJECT_DELETION_SUCCESS = "UI Object Delete - Success",
  AUTOMATION_UI_OBJECT_DELETION_FAILURE = "UI Object Delete - Failure",
  AUTOMATION_UI_OBJECT_DELETE_VALIDATION_FAILURE = "UI Object Delete Validation - Failure",
  AUTOMATION_UI_OBJECT_LOCATOR_DELETION_SUCCESS = "UI Object Locator Deleted Successfully",
  AUTOMATION_UI_OBJECT_CREATE_SUCCESS = "UI Object Create - Success",
  AUTOMATION_UI_LOCATOR_CREATE_SUCCESS = "UI Locator Create - Success",
  AUTOMATION_UI_OBJECT_UPDATE_SUCCESS = "UI Object Update - Success",
  AUTOMATION_UI_OBJECT_UPDATE_FAILURE = "UI Object Update - Failure",
  AUTOMATION_TEST_SUITE_DELETION_SUCCESS = "Test Suite Delete - Success",
  AUTOMATION_TEST_SUITE_DELETION_FAILURE = "Test Suite Delete - Failure",
  AUTOMATION_TEST_SUITE_UPDATE_SUCCESS = "Test Suite Update - Success",
  AUTOMATION_TEST_SUITE_UPDATE_FAILURE = "Test Suite Update - Failure",
  AUTOMATION_TEST_SCRIPT_CREATE_SUCCESS = "Test Script Create - Success",
  AUTOMATION_TEST_SCRIPT_UPDATE_SUCCESS = "Test Script Update - Success",
  AUTOMATION_TEST_SCRIPT_UPDATE_FAILURE = "Test Script Update - Failure",
  AUTOMATION_TEST_SCRIPT_DELETE_SUCCESS = "Test Script Delete - Success",
  AUTOMATION_TEST_SCRIPT_DELETE_FAILURE = "Test Script Delete - Failure",
  AUTOMATION_TEST_SUITE_DELETION_FAILURE_HAS_SCRIPTS = "Test Suite Delete - Failure. Some Test Suite Contains Scripts.",
  TEST_CASE_MAP_SUCCESS = "Test Case Mapping - Success",
  TEST_CASE_MAP_FAILURE = "Test Case Mapping - Failure",
  MAPPING_SAVED_SUCCESSFULLY = "Test Case Mapping Save - Success",
  REUSABLE_COMPONENT_DELETION_SUCCESS = "Reusable Component Delete - Success",
  REUSABLE_COMPONENT_DELETION_FAILURE = "Reusable Component Delete - Failure",
  REUSABLE_SCRIPT_DELETION_SUCCESS = "Reusable Script Delete - Success",
  REUSABLE_SCRIPT_DELETION_FAILURE = "Reusable Script Delete - Failure",
  REUSABLE_SCRIPT_UPDATE_SUCCESS = "Reusable Script Update - Success",
  REUSABLE_SCRIPT_UPDATE_FAILURE = "Reusable Script Update - Failure",
  AUTOMATION_PAGES_LOADING_FAILURE = "Pages Load - Failure",
  CONNECTION_CREATE_SUCCESS = "Connection Create - Success",
  CONNECTION_CREATE_FAILURE = "Connection Create - Failure",
  CONNECTION_UPDATE_SUCCESS = "Connection Update - Success",
  CONNECTION_UPDATE_FAILURE = "Connection Update - Failure",
  CONNECTION_DELETE_SUCCESS = "Connection Delete - Success",
  CONNECTION_DELETE_FAILURE = "Connection Delete - Failure",
  CONNECTION_LOAD_FAILURE = "Connection Load - Failure",
  CONNECTION_NAME_DUPLICATE = "Connection Name Already Exists",
  CONNECTION_SUCCESS = "Server Connection - Success",
  CONNECTION_FAILURE = "Server Connection - Failure",
  DB_CONNECTION_SUCCESS = "Database Connection - Success",
  DB_CONNECTION_FAILURE = "Database Connection - Failure",
  DEVICE_CREATE_SUCCESS = "Device Create - Success",
  DEVICE_CREATE_FAILURE = "Device Create - Failure",
  DEVICE_UPDATE_SUCCESS = "Device Update - Success",
  DEVICE_UPDATE_FAILURE = "Device Update - Failure",
  DEVICE_DELETE_SUCCESS = "Device Delete - Success",
  DEVICE_DELETE_FAILURE = "Device Delete - Failure",
  DEVICE_LOAD_FAILURE = "Device Load - Failure",
  LLM_CONNECTION_SUCCESS = "LLM Connection - Success",
  LLM_CONNECTION_FAILURE = "LLM Connection - Failure",
  LLM_CONNECTION_CONFIGURED_SUCCESS = "LLM Connection Configured - Success",
  PARSER_CONNECTION_CONFIGURED_SUCCESS = "Parser Connection Configured - Success",
  PARSER_CONNECTION_SUCCESS = "Parser Connection - Success",
  PARSER_CONNECTION_FAILURE = "Parser Connection - Failure",
  FILE_CONNECTION_CREATE_FAILURE = "File Connection Create - Failure",
  CLIENT_CREATE_SUCCESS = "Client Create - Success",
  CLIENT_CREATE_FAILURE = "Client Create - Failure",
  CLIENT_UPDATE_SUCCESS = "Client Update - Success",
  CLIENT_UPDATE_FAILURE = "Client Update - Failure",
  CLIENT_DELETE_SUCCESS = "Client Delete - Success",
  CLIENT_DELETE_FAILURE = "Client Delete - Failure",
  PROJECT_CREATE_SUCCESS = "Project Create - Success",
  PROJECT_CREATE_FAILURE = "Project Create - Failure",
  PROJECT_UPDATE_SUCCESS = "Project Update - Success",
  PROJECT_UPDATE_FAILURE = "Project Update - Failure",
  PROJECT_DELETE_SUCCESS = "Project Delete - Success",
  PROJECT_DELETE_FAILURE = "Project Delete - Failure",
  PROJECT_LOAD_FAILURE = "Project Load - Failure",
  RELEASE_CREATE_SUCCESS = "Release Create - Success",
  RELEASE_CREATE_FAILURE = "Release Create - Failure",
  RELEASE_UPDATE_SUCCESS = "Release Update - Success",
  RELEASE_UPDATE_FAILURE = "Release Update - Failure",
  RELEASE_DELETE_SUCCESS = "Release Delete - Success",
  RELEASE_DELETE_FAILURE = "Release Delete - Failure",
  RELEASE_LOAD_FAILURE = "Release Load - Failure",
  RELEASE_SELECTION_REQUIRED = "Execution Blocked - Select a Release Before Executing",
  TEST_REPORT_SUMMARY_LOAD_FAILURE = "Test Report Summarizer Data Load - Failure",
  SOURCE_CODE_MAPPING_FAILURE = "Source Code Mapping - Failure",
  MAPPING_UPDATE_SUCCESS = "Mapping Update - Success",
  MAPPING_UPDATE_FAILURE = "Mapping Update - Failure",
  RECOMMENDATION_FETCHING_FAILURE= "Recommendation Load - Failure",
  RECOMMENDATION_GENERATION_FAILURE= "Recommendation Generate - Failure",
  STORY_DELETE_SUCCESS = "Story Delete - Success",
  STORY_DELETE_FAILURE = "Story Delete - Failure",
  TEST_CASE_GENERATION_FAILURE = "Test Case Generate - Failure",
  TEST_CASE_GENERATION_SUCCESS = "Test Case Generate - Success",
  TEST_SCRIPTS_GENERATION_FAILURE = "Test Scripts Generate - Failure",
  TEST_SCRIPTS_GENERATION_SUCCESS = "Test Scripts Generate - Success",
  EXCEL_DOWNLOAD_FAILURE = "Excel Download - Failure",
  FEEDBACK_SUBMIT_SUCCESS = "Feedback Submit - Success",
  FEEDBACK_SUBMIT_FAILURE = "Feedback Submit - Failure",
  SESSION_TIMEOUT =  "Session Time Out. Please Login Again",
  PAGE_URL_INVALID = "Page URL - Should Not Contain White Spaces",
  PAGE_NAME_INVALID = "Page Name - Should Not Contain White Spaces or Special Characters",
  PROJECT_DOWNLOAD_FAILURE = "Project Download - Failure",
  PAGE_NAME_DUPLICATE = "Page Name Already Exists",
  APP_NAME_DUPLICATE = "Application Name Already Exists",
  LOCATOR_DUPLICATE_WARNING = "Locator Type - Duplicate Entry Not Allowed",
  UI_OBJECT_NAME_DUPLICATE = "UI Object Name Already Exists",
  REUSABLE_COMPONENT_NAME_DUPLICATE = "Reusable Component Name Already Exists",
  REUSABLE_SCRIPT_NAME_DUPLICATE = "Reusable Script Name Already Exists",
  FILE_UPLOAD_SUCCESS = "File Upload - Success",
  FILE_DELETE_SUCCESS = "File Delete - Success",
  FILE_DELETE_FAILURE = "File Delete - Failure",
  MODEL_DELETE_SUCCESS = "Model Delete - Success",
  MODEL_DELETE_FAILURE = "Model Delete - Failure",
  FILE_UPLOAD_FAILURE = "File Upload - Failure",
  FILE_UPLOAD_SAME_NAME_FAILURE = "Duplicate file name - Failure",
  TEST_CASE_LOAD_FAILURE = "Test Case Data Load - Failure",
  INVALID_PLAN_NAME = "Plan Name Validation - Should Not Contain 'AdHocTestplan'",
  TEST_CASE_SELECTION_REQUIRED = "Selection Required - Choose Version, Browser, and Execution Engine for Each Case",
  TEST_CASE_SELECTION_REQUIRED_DEVICE = "Selection Required - Choose Version, Browser, and Device for Each Case",
  TEST_PLAN_LOAD_FAILURE = "Test Plan Load - Failure",
  TEST_PLAN_UPDATE_SUCCESS = "Test Plan Update - Success",
  TEST_PLAN_NAME_DUPLICATE = "Test Plan Name Already Exists",
  TEST_PLAN_UPDATE_FAILURE = "Test Plan Update - Failure",
  TEST_PLAN_DELETE_SUCCESS = "Test Plan Delete - Success",
  TEST_PLAN_DELETE_FAILURE = "Test Plan Delete - Failure",
  TEST_PLAN_CREATE_SUCCESS = "Test Plan Create - Success",
  TEST_PLAN_CREATE_FAILURE = "Test Plan Create - Failure",
  SCHEDULE_UPDATE_SUCCESS = "Schedule Update - Success",
  SCHEDULE_UPDATE_FAILURE = "Schedule Update - Failure",
  SCHEDULE_CREATE_SUCCESS = "Schedule Create - Success",
  SCHEDULE_CREATE_FAILURE = "Schedule Create - Failure",
  SCHEDULE_DELETE_SUCCESS = "Schedule Delete - Success",
  SCHEDULE_DELETE_FAILURE = "Schedule Delete - Failure",
  SCHEDULE_LOAD_FAILURE = "Schedule Load - Failure",
  SCHEDULE_INITIATE_SUCCESS = "Schedule Initiate - Success",
  SCHEDULE_INITIATE_FAILURE = "Schedule Initiate - Failure",
  EXECUTION_INITIATE_SUCCESS = "Execution Initiate - Success",
  EXECUTION_INITIATE_FAILURE = "Execution Initiate - Failure",
  TEST_CASE_ID_COPY_SUCCESS = "Test Case Id Copied to Clipboard",
  TESTCASE_CODE_MAPPING_SUCCESS = "Test Case to Source Code Mapping - Success",
  TESTCASE_CODE_MAPPING_FAILURE = "Test Case to Source Code Mapping - Failure",
  TESTCASE_CODE_MAPPING_UPDATE_SUCCESS = "Test Case to Source Code Mapping Update - Success",
  TESTCASE_CODE_MAPPING_UPDATE_FAILURE = "Test Case to Source Code Mapping Update - Failure",
  CODE_SNIPPET_GENERATION_FAILURE = "Code Snippet Generate - Failure",
  CODE_SNIPPET_GENERATION_SUCCESS = "Code Snippet Generate - Success",
  IMPACTED_TESTCASES_GENERATION_SUCCESS = "Impacted Test Cases Generate - Success",
  IMPACTED_TESTCASES_GENERATION_FAILURE = "Impacted Test Cases Generate - Failure",
  IMPACTED_TESTCASES_LOAD_FAILURE = "Impacted Test Cases Load - Failure",
  MOST_IMPACTED_TESTCASES_LOAD_FAILURE = "Most Impacted Test Cases Load - Failure",
  DEFECT_REPORT_UPLOAD_REQUIRED = "Defect Report - Upload Required",
  MAPPING_DELETION_SUCCESS = "Mapping Delete - Success",
  MAPPING_DELETION_FAILURE = "Mapping Delete - Failure",
  CLIENT_NAME_DUPLICATE = "Client/Project Name Already Exists",
  DATA_MAPPING_FAILURE ="Mapping Data Connections - Failure",
  USER_ONBOARD_SUCCESS = "User Onboard - Success",
  USER_ONBOARD_FAILURE = "User Onboard - Failure",
  METADATA_DELETE_FAILURE = "Metadata Delete - Failure",
  METADATA_DELETE_SUCCESS = "Metadata Delete - Success",
  METADATA_GENERATE_FAILURE = "Metadata Generate - Failure",
  METADATA_GENERATE_SUCCESS = "Metadata Generate - Success",
  METADATA_CATALOGUE_FAILURE = "Metadata Catalogue - Failure",
  METADATA_INITIALIZED = "Default Metadata Fields Added.",
  METADATA_INITIALIZED_FAILED = "Could Not Save Default Metadata Fields.",
  METADATA_EXIST = "This Attribute Already Exists.",
  GIT_VALIDATE_SUCCESS = "Git credentials verification - Success",
  GIT_VALIDATE_FAILURE = "Git credentials verification - Failure",
  ACTIVE_TESTCASES = "Optimization skipped: The number of stable test cases is below the required threshold (≤10) in the following release(s): ",
  ERROR_GETTING_UPLOADED_FILE = "Manual Uploaded File Load - Failure",
  ERROR_GETTING_PROVIDER_FIELDS = "Provider Fields Load - Failure",
  ROLLBACK_UPLOADED_FILE_FAILURE = "Uploaded File Roll Back - Failure",
  ROLLBACK_UPLOADED_FILE_SUCCESS = "Uploaded File Roll Back - Success",
  TEST_SCRIPT_GENERATION_FAILURE = "Test Script Generation - Failure",
  CREATE_SERVICE_SUCCESS = "Service Create - Success",
  CREATE_SERVICE_FAILURE = "Service Create - Failure",
  DELETE_SERVICE_SUCCESS = "Service Delete - Success",
  DELETE_SERVICE_FAILURE = "Service Delete - Failure",
  UPDATE_SERVICE_SUCCESS = "Service Update - Success",
  UPDATE_SERVICE_FAILURE = "Service Update - Failure",
  CREATE_SERVICE_OPERATION_SUCCESS = "Service Operation Create - Success",
  CREATE_SERVICE_OPERATION_FAILURE = "Service Operation Create - Failure",
  DELETE_SERVICE_OPERATION_SUCCESS = "Service Operation Delete - Success",
  DELETE_SERVICE_OPERATION_FAILURE = "Service Operation Delete - Failure",
  UPDATE_SERVICE_OPERATION_SUCCESS = "Service Operation Update - Success",
  UPDATE_SERVICE_OPERATION_FAILURE = "Service Operation Update - Failure",
  CREATE_OPERATION_PARAMETER_SUCCESS = "Parameter Create - Success",
  CREATE_OPERATION_PARAMETER_FAILURE = "Parameter Create - Failure",
  DELETE_OPERATION_PARAMETER_SUCCESS = "Parameter Delete - Success",
  DELETE_OPERATION_PARAMETER_FAILURE = "Parameter Delete - Failure",
  UPDATE_OPERATION_PARAMETER_SUCCESS = "Parameter Update - Success",
  UPDATE_OPERATION_PARAMETER_FAILURE = "Parameter Update - Failure",
  CREATE_OPERATION_HEADER_SUCCESS = "Header Create - Success",
  CREATE_OPERATION_HEADER_FAILURE = "Header Create - Failure",
  DELETE_OPERATION_HEADER_SUCCESS = "Header Delete - Success",
  DELETE_OPERATION_HEADER_FAILURE = "Header Delete - Failure",
  UPDATE_OPERATION_HEADER_SUCCESS = "Header Update - Success",
  UPDATE_OPERATION_HEADER_FAILURE = "Header Update - Failure",
  RETURN_TYPE_ADD_SUCCESS = "Return Type Add - Success",
  RETURN_TYPE_ADD_FAILURE = "Return Type Add - Failure",
  APP_CONTEXT_UPLOAD_FAILURE = "Application Context Upload - Failure",
  APP_CONTEXT_UPLOAD_SUCCESS = "Application Context Upload - Success",
  APP_CONTEXT_DELETE_FAILURE = "Application Context Delete - Failure",
  APP_CONTEXT_DELETE_SUCCESS = "Application Context Delete - Success",
  APP_CONTEXT_GENERATION_SUCCESS = "Application Context Generation - Success",
  APP_CONTEXT_GENERATION_FAILURE = "Application Context Generation - Failure",
  APP_CONTEXT_LOAD_FAILURE = "Application Context Load - Failure",
  FRAMEWORK_TYPE_SELECTION_REQUIRED = "Framework Type - Selection Required",
  NO_RELEASE_SELECTED = "Please Select a Release Before Proceeding.",
  PRAMETER_KEY_EMPTY = "Parameter Name/Key Cannot Be Empty",
  SERVICE_OPERATION_DELETE_VALIDATION_FAILURE = "Service Operation Delete Validation - Failure",
  FETCH_LOGS_FAILURE = "Fetch Logs - Failure",
  EXECUTIONS_DELETION_SUCCESS = "Execution Reports Delete - Success",
  EXECUTIONS_DELETION_FAILURE = "Execution Reports Delete - Failure",
  SCRIPT_DUPLICATE_SUCCESS = "Script Duplicated Successfully",
  SCRIPT_COPY_SUCCESS = "Script Copied and Moved Successfully",
  AI_APPROACH_SET_FAILED = "Failed to Set AI Approach",
  AI_APPROACH_SET_TO_AGENTIC = "AI Approach Set to Agentic",
  AI_APPROACH_SET_TO_NON_AGENTIC = "AI Approach Set to Non-Agentic",
  AI_GET_ALL_CHATS = "An Error Occurred While Retrieving Chat Messages.",
  AI_GET_ALL_CHAT_HISTORY = "An Error Occurred While Retrieving Chat History.",
  AI_GET_ALL_CHAT_HISTORY_SAMPLE = "An Error Occurred While Retrieving Sample Chat History.",
  CHAT_CONTENT_COPY_SUCCESS = "Chat Content Copied to Clipboard",
  ONLY_ONE_SUITE_ALLOWED = "Only One Test Suite Is Allowed in the Table",
  SOMETHING_WENT_WRONG = "Something Went Wrong. Please Try Again Later.",
  SUCCESS_DELETE_TABLE = "Table Delete - Success.",
  FAILURE_DELETE_TABLE = "Table Delete - Failure.",
  TABLE_SYNC_SUCCESS = "Custom Tables Synced Successfully!",
  TABLE_SYNC_FAILURE = "Failed to Sync Custom Tables!",
  DATA_MISSING = "Missing Required Data. Please Try Again.",
  UPDATING_CHAT_TITLE_ERROR = "Chat Title Update - Failure!.",
  UPDATING_CHAT_TITLE_SUCCESS = "Chat Title Update - Success!",
  SAMPLE_CHATS_LOADING_ERROR = "An Error Occurred While Retrieving Sample Chats.",
  NO_DATA_AVAILABLE_TO_DOWNLOAD = "No Data Available to Download.",
  PIPELINE_SAVE_FAILURE = "Failed to Save Pipeline Configuration.",
  EMPTY_ROW = "Row is Empty!",
  SELECT_AT_LEAST_ONE_TEST_PLAN_OR_SUITE = "Please Select at least One Test Plan or Suite Before Proceeding.",
  FAILED_TO_LOAD_CICD_PLATFORMS = "Failed to Load CI/CD Platforms.",
  FAILED_TO_LOAD_CICD_EXECUTIONS = "Failed to Load CI/CD Executions.",
  FAILED_TO_LOAD_CICD_INTEGRATION_GUIDE = "Failed to Load CI/CD Integration Guide.",
  SELECT_FILE_CONNECTION = "Please Select a File Connection.",
  APP_CONTEXT_SETUP_SUCCESS = "Application Context Setup - Success",
  APP_CONTEXT_SETUP_FAILURE = "Application Context Setup - Failure" ,
  BAD_REQUEST = "Bad request: Please check your input and try again",
  SELECT_BROWSER_FOR_ALL_TEST_CASES = "Please Select a Browser for Test Cases Before Saving.",
  SELECT_BROWSER_AND_EXECUTION_ENGINE_BEFORE_SAVING = "Please Select a Browser/Execution Engine Before Saving.",
  ERROR_WHILE_RETRIEVING_MOBILE_TASK = "Error While Retrieving Mobile Task Details.",
  SYNCING_CUSTOM_TABLE_ERROR = 'An Error Occurred While Syncing Custom Tables.',
  TEST_CASE_DETAILS_FAILURE = "Load Test Case Details - Failure",
  TEST_CASE_DATA_SAVE_SUCCESS = "Test Case Data Save - Success",
  TEST_CASE_DATA_SAVE_FAILURE = "Test Case Data Save - Failure",
  DATA_PERSISTED_SUCCESS = "Data Persist - Success",
  DATA_PERSISTED_FAILURE = "Data Persist - Failure",
  NO_ITEMS_SELECTED_FOR_DELETION = "No Items Selected for Deletion",
  FETCH_CHAT_HISTORY_FAILURE = "Something Went Wrong While Fetching Chat History.",
  NO_DATA_SELECTED = "No Data Selected, Please Select Any.",
  CANNOT_CANCEL_MISSING_VERSION_OR_PROJECT_ID = "Cannot Cancel: Missing Version or Project ID",
  TEST_CASE_GENERATION_CANCELLED = "Test Case Generation - Cancelled",
  TEST_CASE_GENERATION_CANCEL_FAILURE= "Test Case Generation Cancel - Failure",
  SELECT_AT_LEAST_ONE_TEST_PLAN_BEFORE_SAVING = "Please Select at least One Test Plan Before Saving.",
  SELECT_AT_LEAST_ONE_TEST_SCRIPT_BEFORE_SAVING = "Please Select at least One Test Script Before Saving.",
  TEST_PLAN_EXECUTION_SETTINGS_SAVE_SUCCESS = "Test Plan Execution Settings Save - Success",
  TEST_PLAN_EXECUTION_SETTINGS_SAVE_FAILURE = "Test Plan Execution Settings Save - Failure",
  AD_HOC_TEST_SCRIPTS_SAVE_SUCCESS = "Ad-Hoc Test Scripts Save - Success",
  AD_HOC_TEST_SCRIPTS_SAVE_FAILURE = "Ad-Hoc Test Scripts Save - Failure",
  API_SCRIPT_PROGRESS_TRACK_FAILURE = "API Script Progress Track - Failure",
  API_SCRIPT_GENERATION_CANCELLED = "API Script Generation - Cancelled",
  EXTRACT_SOURCE_CODE_FAILURE = "Extract Source Code - Failure",
  ANALYZE_MAPPING_FAILURE = "Analyze Mapping - Failure",
  GENERATE_MAPPING_FAILURE = "Generate Mapping - Failure",
  FAILED_TO_REMOVE_PIPELINES = "Failed to Remove One or More Pipelines.",
  FAILED_TO_LOAD_PIPELINE_DETAILS = "Failed to Load Pipeline Details.",
  MAPPING_NAME_ALREADY_EXISTS = "Mapping Name Already Exists.",
  RESUME_EXTRACTION = 'Resuming Ongoing User Story Extraction',
  EXTRACTION_INPROGRESS = 'An Extraction Is Already In Progress. Please Wait for It to Complete.',
  PROMPT_VERSION_LOAD_FAILURE = 'Prompt Versions Load - Failure',
  PROMPT_VERSION_DELETE_FAILURE = "Prompt Version Delete - Failure",
  PROMPT_VERSION_DELETE_SUCCESS = "Prompt Version Delete - Success",
  PROMPT_VERSION_UPDATE_FAILURE = "Prompt Version Update - Failure",
  PROMPT_VERSION_UPDATE_SUCCESS = "Prompt Version Update - Success",
  PROMPT_VERSION_SET_ACTIVE_SUCCESS = "Prompt Version Set Active - Success",
  PROMPT_VERSION_SET_ACTIVE_FAILURE = "Prompt Version Set Active - Failure",
  PROMPT_CREATE_SUCCESS = "Prompt Create - Success",
  PROMPT_CREATE_FAILURE = "Prompt Create - Failure",
  FILTERED_PROMPT_LOAD_FAILURE = "Load Filtered Prompts - Failure",
  LOAD_SERVICES_FAILURE = 'Load Services - Failure',
  PROMPT_LOAD_FAILURE = 'Prompts Load - Failure',
  LOAD_KEYS_FAILURE = "Load Prompt Keys - Failure"

}
